import { gql } from '@apollo/client/core'
import { projectAccessFragment } from '/@/common/projects/api/fragments'
import {
  designChallengeFragment,
  designChallengeSubmissionFragment,
} from '/@/common/designChallenges/fragments'
import { roomFragment } from '/@/common/rooms/fragments'
import { mockupAccessFragment } from '/@/common/viz/accessFragments'
import { scaledImagesFragment } from '/@/common/images/fragments'

export const viziVersionFragment = gql`
  fragment ViziVersionProps on MockupVersion {
    id
    imageUrl
    createdAt
    designerId
    mockupId
  }
`

export const viziVersionWithDataFragment = gql`
  ${viziVersionFragment}
  fragment ViziVersionWithDataProps on MockupVersion {
    ...ViziVersionProps
    dataRaw
    dataUrl
  }
`

export const viziFragment = gql`
  ${designChallengeFragment}
  ${designChallengeSubmissionFragment}
  ${viziVersionFragment}
  ${projectAccessFragment}
  ${mockupAccessFragment}
  ${scaledImagesFragment}
  ${roomFragment}
  fragment ViziProps on Mockup {
    id
    name
    thingType
    updatedAt
    note
    mockupType
    roomType
    roomTypeExtra
    room {
      ...RoomProps
    }
    isTemplate
    dataRaw
    dataUrl
    imageUrl
    setupState
    scaledImages {
      ...ScaledImagesProps
    }
    costVisibility
    vizVersion
    isEdited
    project {
      id
      name
      visibility
      access {
        ...ProjectAccessProps
      }
      status
      projectType
      designer {
        id
        firstName
        lastName
        nickname
        imageUrl
        sign
      }
    }
    section {
      id
      name
    }
    dailyPlay {
      id
      name
      prompt
      designerInfo {
        id
        completedAt
        dismissedAt
      }
      vendor {
        id
        name
        isVerified
        logoUrl
      }
    }
    task {
      id
      description
      goal {
        id
        designerInfo {
          id
        }
      }
      designerInfo {
        id
        completedAt
      }
    }
    designerId
    designer {
      id
      firstName
      lastName
      imageUrl
      nickname
      sign
    }
    defaultBackgroundImageUrl
    template {
      id
    }
    mockupTemplate {
      id
      name
      roomTypes
      styles
    }
    designChallenge {
      ...DesignChallengeProps
    }
    designChallengeSubmission {
      ...DesignChallengeSubmissionProps
    }
    latestVersion {
      ...ViziVersionProps
    }
    access {
      ...MockupAccessProps
    }
    limits {
      id
      mockupId
      mockupLimitType
      current
      limit
    }
    optionGroups {
      id
      groupId
      name
      options {
        id
        objectId
        name
        isSelected
        isFavorite
      }
    }
  }
`
